import {env} from '@/helper/env';
import {getReportedEvent, saveReportedEvent} from '@/storage/support-event';
import type {SupportEvent} from '@/storage/support-event';
import {setProfile, track, pageView} from './et';
import {track as ga4Track, pageView as ga4PageView} from './ga4';

export const sd = resolveSD();

function resolveSD() {
  if (!env.isServer && !env.isBot) {
    return {
      setProfile(record) {
        setProfile(record);
      },
      track(eventName, params) {
        track(eventName, params);
        ga4Track(eventName, params);
      },
      pageView(params) {
        pageView(params);
        ga4PageView(params);
      },
    };
  }

  return {
    setProfile(record) {},
    track(eventName, params) {},
    pageView(params) {},
  };
}

/**
 * 上报客户端对某个功能的支持情况
 * @param event
 */
export function trackSupportEvent(event: SupportEvent) {
  if (!getReportedEvent(event)) {
    sd.track(event, {
      support: !!window[event],
    });
    saveReportedEvent(event, true);
  }
}
